export default {
	styleOverrides: {
		root: {
			height: 'auto',
			padding: '0px',
		},
		sizeSmall: {
			width: '24px',
			minWidth: '24px',
			height: '24px',
			'& svg': {
				width: '16px',
				height: '16px',
			},
		},
		sizeMedium: {
			width: '32px',
			minWidth: '32px',
			height: '32px',
			'& svg': {
				width: '16px',
				height: '16px',
			},
		},
		sizeLarge: {
			width: '40px',
			minWidth: '40px',
			height: '40px',
			'& svg': {
				width: '24px',
				height: '24px',
			},
		},
	},
};
